import { render, staticRenderFns } from "./AssistRequestContent.vue?vue&type=template&id=745a08f6&scoped=true"
import script from "./AssistRequestContent.vue?vue&type=script&lang=ts"
export * from "./AssistRequestContent.vue?vue&type=script&lang=ts"
import style0 from "./AssistRequestContent.vue?vue&type=style&index=0&id=745a08f6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745a08f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('745a08f6')) {
      api.createRecord('745a08f6', component.options)
    } else {
      api.reload('745a08f6', component.options)
    }
    module.hot.accept("./AssistRequestContent.vue?vue&type=template&id=745a08f6&scoped=true", function () {
      api.rerender('745a08f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/AssistRequestContent.vue"
export default component.exports